import { Plus } from "lucide-react";
import GlassContainer from "@/shared/components/glasscontainer";
import icon from "@/assets/icons/brain.webp";

export interface WorkspacesSidebarProps {
  total: number;
  totalAutomations: number;
  loading: boolean;
  onCreate: () => void;
}

export function WorkspacesSidebar({
  total,
  totalAutomations,
  loading,
  onCreate,
}: WorkspacesSidebarProps) {
  return (
    <aside className="flex min-h-screen w-80 shrink-0 flex-col items-center justify-start overflow-y-auto px-8 pb-20">
      <img src={icon} className="size-68" />

      <h1 className="mb-3 text-center text-2xl font-bold tracking-tight text-foreground">
        Workspaces
      </h1>
      <p className="text-center text-sm leading-relaxed text-foreground/50">
        Agrupá las automatizaciones de una misma aplicación y seguilas desde un único dashboard con
        los KPIs de todas ellas.
      </p>

      <div className="mt-8 w-full space-y-3">
        <button
          onClick={onCreate}
          className="group flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-accent px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-accent/90"
        >
          <Plus className="size-4" />
          <span>Nuevo workspace</span>
        </button>

        <GlassContainer className="flex items-center justify-between p-4">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground/60">Total</p>
          <p className="text-3xl font-bold text-foreground">{loading ? "—" : total}</p>
        </GlassContainer>
        <GlassContainer className="flex items-center justify-between p-4">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground/60">
            Automatizaciones
          </p>
          <p className="text-3xl font-bold text-foreground">{loading ? "—" : totalAutomations}</p>
        </GlassContainer>
      </div>
    </aside>
  );
}
